import MDBox from "components/MDBox";
import { styled } from '@mui/system';


export const BrandBox = styled(MDBox)(({ theme }) => ({
    width: '126px',
}));

export const BrandBoxMini = styled(MDBox)(({ theme }) => ({
    width: '35px',
}));